import { createSlice } from '@reduxjs/toolkit'
import {
  createCaseStudiesAction,
  deleteCaseStudiesAction,
  getCaseStudiesAction,
  updateCaseStudiesAction,
} from './caseStudy.action'

const initialState: Study.StudyState = {
  isLoading: false,
  error: null,
  studies: {
    limit: 0,
    page: 0,
    records: [],
    total: 0,
    totalPage: 0,
  },
}

const { actions, reducer } = createSlice({
  name: 'case_study_slice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCaseStudiesAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(getCaseStudiesAction.fulfilled, (state, action) => {
        state.isLoading = false
        state.studies = action.payload
      })
      .addCase(getCaseStudiesAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })

      .addCase(createCaseStudiesAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(createCaseStudiesAction.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(createCaseStudiesAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })

      .addCase(updateCaseStudiesAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(updateCaseStudiesAction.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateCaseStudiesAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })

      .addCase(deleteCaseStudiesAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(deleteCaseStudiesAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteCaseStudiesAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
  },
})

export { reducer }
export default actions
